/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useEffect, useState } from 'react'
import BackButton from 'components/Button/BackButton'
import { useDispatch, useSelector } from 'react-redux'
import * as actions from '../../redux/actions'
import { Link, useParams, useHistory } from 'react-router-dom'
import _ from 'lodash'
import DateRangePicker from '@wojtekmaj/react-daterange-picker'
import { useTranslation } from 'react-i18next'
import { useForm, useFieldArray, Controller } from 'react-hook-form'

// components
import { Box, Button, Flex } from '@chakra-ui/react'
import SpinnerLoading from 'components/Loading/SpinnerLoading'
import ChartRenderingComponent from '../../components/Graphs/Functions/ChartRendering'
import dayjs from 'dayjs'

export default function StatisticGraph() {
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = useState(false)
  const [currentStation, setcurrentStation] = useState()
  const [currentDateRange, setcurrentDateRange] = useState([
    undefined,
    undefined,
  ])
  const [samplingTime, setSamplingTime] = useState(null)
  const [selectedChart, setSelectedChart] = useState(null)
  const dispatch = useDispatch()
  const params = useParams()
  const allStations = useSelector((state) => state.station)
  const allLogs = useSelector((state) => state.log)
  const me = useSelector((state) => state.me)
  const system = useSelector((state) => state.system)
  const [isGraphShowing, setIsGraphShowing] = useState(false)
  const [tickAmount, setTickAmount] = useState(8)
  const [valueFormat, setValueFormat] = useState('YYYY-MM-DD HH:mm')
  const history = useHistory()
  //const [selectData, setSelectData] = useState([])
  const { register, handleSubmit, reset, control, setValue, watch } = useForm()

  const { fields, append, remove, insert } = useFieldArray({
    control,
    name: 'data',
  })
  const handleRemove = (index) => {
    remove(index)
  }

  useEffect(() => {
    if (me && me._id && currentStation) {
      if (_.includes(me.duty, 'ALLAREA') || me.duty === currentStation._id) {
        //   dispatch(actions.logOnEachStation(currentStation._id))
      } else {
        console.log('ผู้ใช้ไม่มีสิทธิเข้าใช้')
      }
    }
    return () => {}
  }, [me, currentStation])

  useEffect(() => {
    dispatch(actions.stationAll()).then(() => setIsLoading(true))
    return () => {}
  }, [])

  useEffect(() => {
    if (allStations) {
      const tempcurrentStatus = _.find(
        allStations.arr,
        (station) => station._id === params.stationId
      )
      setcurrentStation(tempcurrentStatus)
      //console.log('Curent Station', currentStation)
    }
    return () => {}
  }, [params, allStations])

  const logOnSpecificDate = () => {
    //console.log('fleid', watch('data'))

    if (
      currentDateRange === undefined ||
      currentDateRange[0] === undefined ||
      currentDateRange[1] === undefined ||
      samplingTime === null
    ) {
      window.alert(
        ' ขออภัย คุณต้องกำหนดช่วงเวลาก่อน\n Sorry Please select range of time'
      )
    } else {
      setIsLoading(false)
      dispatch(
        actions.logOnDaySpecific(
          currentStation?._id,
          currentDateRange[0],
          currentDateRange[1],
          samplingTime
        )
      ).then(() => {
        setTimeout(() => {
          setIsLoading(true)
          setIsGraphShowing(true)
        }, 1500)
      })
    }
  }

  const renderGraph = () => {
    //console.log('all log ', allLogs)
    let temp = []
    let userGauge = _.filter(currentStation.charts, (chart, index) =>
      _.map(watch('data'), (item) => {
        if (item.selectData === chart._id) {
          temp.push(chart)
        }
      })
    )
    // console.log('data', userGauge, temp)

    return (
      <ChartRenderingComponent
        multichart={true}
        chartData={temp}
        data={allLogs}
        graphMax={currentDateRange[1]}
        graphMin={currentDateRange[0]}
        setGraphMax={undefined}
        setGraphMin={undefined}
        setTickAmount={setTickAmount}
        setValueFormat={setValueFormat}
        tickAmount={undefined}
        valueFormat={valueFormat}
        stationData={currentStation}
        enableTimeSelect={false}
      />
    )
  }

  const genChartList = () => {
    if (_.size(currentStation.charts)) {
      return _.map(currentStation.charts, (chart, index) => (
        <option key={index} value={chart._id}>
          {chart.chartLabel}
        </option>
      ))
    } else {
      return <option value="" selected disabled></option>
    }
  }
  return isLoading && currentStation ? (
    <div className="relative flex flex-col min-w-0 break-words bg-gray-100 w-full mb-6 shadow-lg rounded print-area">
      <div className="rounded-t mb-0 px-4 py-3 bg-transparent">
        <div className="flex flex-wrap items-center print-area">
          <div className="relative w-full max-w-full flex-grow flex-1">
            <p className="print-only text-xl">
              {system?.name} | {system?.systemOwner}
              <hr />
            </p>
            <h6 className="uppercase text-gray-500 mb-1 text-xs font-semibold font-sans print-disable">
              {t('dataAndStat.dataAndStat')}
            </h6>
            <h2 className="text-gray-800 text-2xl font-bold font-sans">
              {t('dashboard.graph')} {currentStation.name}
            </h2>
            <p className="text-base text-gray-500 mb-1 font-sans">
              {currentStation.location}
            </p>
          </div>
        </div>
        <Button>
          <BackButton />
        </Button>
      </div>

      <div className="flex flex-wrap p-4 gap-4 print-disable">
        {/* ช่วงเวลา */}
        <div className="w-full gap-2 flex flex-wrap my-2">
          <label className="block uppercase text-gray-700 text-xs font-bold my-2 mx-2">
            {t('dataAndStat.timePeriod')}
          </label>
          <DateRangePicker
            onChange={(value) => {
              if (value) {
                let tempStart = value[0].getTime()
                let tempEnd = value[1].getTime()
                setcurrentDateRange([tempStart, tempEnd])
              } else {
                setcurrentDateRange([undefined, undefined])
              }
              setIsGraphShowing(false)
            }}
            value={currentDateRange}
          />
        </div>

        {/* เลือก Sampling Time */}
        <div className="w-full gap-4 flex flex-wrap my-2">
          <label className="block uppercase text-gray-700 text-xs font-bold my-2 mx-2">
            {t('dataAndStat.fetchEvery')}
          </label>
          <select
            name="samplingTime"
            type="text"
            required
            className=" placeholder-gray-400 text-gray-700 bg-white rounded text-xs shadow focus:outline-none focus:shadow-outline  ease-linear transition-all duration-150"
            value={samplingTime}
            onChange={(s) => {
              console.log('selectedSamplingTime', s.target.value)
              setSamplingTime(s.target.value)
            }}
          >
            <option value="" disabled selected>
              {t('dataAndStat.selectTime')}
            </option>
            <option
              key="0"
              value="log1mm"
              disabled={
                dayjs(currentDateRange[1]).diff(currentDateRange[0], 'day') > 3
                  ? true
                  : false
              }
              className={`${
                dayjs(currentDateRange[1]).diff(currentDateRange[0], 'day') > 3
                  ? 'bg-gray-400'
                  : ''
              }`}
            >
              1 {t('dateTime.minute')}
            </option>
            <option
              key="1"
              value="log1h"
              disabled={
                dayjs(currentDateRange[1]).diff(currentDateRange[0], 'day') > 31
                  ? true
                  : false
              }
              className={`${
                dayjs(currentDateRange[1]).diff(currentDateRange[0], 'day') > 31
                  ? 'bg-gray-400'
                  : ''
              }`}
            >
              1 {t('dateTime.hours')}
            </option>
            <option key="2" value="log1d">
              1 วัน
            </option>
            <option key="3" value="log1m">
              1 เดือน
            </option>
          </select>
          <Button
            colorScheme="blue"
            size="sm"
            onClick={() => {
              logOnSpecificDate()
            }}
          >
            {t('dataAndStat.fetch')}{' '}
          </Button>
          <Button
            colorScheme="green"
            size="sm"
            onClick={() => append({ selectData: '' })}
          >
            เพิ่มข้อมูลใหม่
          </Button>
          {isGraphShowing && (
            <div className="gap-2 flex flex-wrap ">
              <Button
                colorScheme="red"
                size="sm"
                hidden={!isGraphShowing && !selectedChart}
                onClick={() => {
                  setTimeout(() => {
                    window.print()
                  }, 1000)
                }}
              >
                PDF
              </Button>
            </div>
          )}
        </div>
        <div className="w-full gap-4 flex flex-wrap my-2">
          {_.map(fields, (row, index) => (
            <div key={row.id}>
              <div className="flex text-sm justify-between">
                <h5 className="mb-2">ข้อมูลที่ {index + 1} </h5>
                <Button
                  colorScheme="red"
                  size="sm"
                  onClick={() => handleRemove(index)}
                >
                  {t('utility.delete')}
                </Button>
              </div>

              <select
                name={`data.${index}.selectData`}
                required
                {...register(`data.${index}.selectData`)}
                className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
              >
                {genChartList()}
              </select>
            </div>
          ))}
        </div>
      </div>
      <div className="p-6">
        {isGraphShowing === false && watch('data')?.length !== 0 ? (
          <div></div>
        ) : (
          renderGraph()
        )}
      </div>
    </div>
  ) : (
    <SpinnerLoading />
  )
}
